var render = function render(){var _vm=this,_c=_vm._self._c;return _c('s-purchasing-cyber-protect-home-office-v1',_vm._b({},'s-purchasing-cyber-protect-home-office-v1',{ ..._vm.$props, content: _vm.content, pageProductCards: _vm.pageProductCards },false))
}
var staticRenderFns = []

export { render, staticRenderFns }